import { connect } from 'react-redux'
import AlertsActions from '../../Redux/AlertsRedux'
import Header from './header-logo'

const mapDispatchToProps = dispatch => ({
  getAlerts: (pageNumber = 1, pageSize = 5) => dispatch(AlertsActions.unreadAlertsRequest(null, pageNumber, pageSize))
})

export default connect(null, mapDispatchToProps)(Header)
